import FilterRegister from "../../../../components/filter/register-basic";
import reqTipoCliente from "../../../../services/reqMultiTenant/reqTipoCliente";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterClientType = () => {
	const options = {
		id: "id_tipocliente", //usado para saber qual field usar para atualizar
		ident: "clienttype", //usado para definir os event listners
		identFilter: "filterClientType", //usado para definir os event listners
		title: "Tipo de Cliente",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "nome", label: "Tipo Cliente", align: "left" },
			{ key: "obs", label: "Observação", align: "left" },
			{ key: "empty1", label: "", align: "left" },
			{ key: "empty2", label: "", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		identReport: `reportTypeClient`, //usado para definir os event listners
		reportColumns: [
			{ key: "nome", label: "Tipo Cliente", align: "left", visible: true },
			{ key: "codigo", label: "Código", align: "center", visible: true },
			{ key: "ativo", label: "Status", align: "center", format: "badgePgto", visible: true },
			{ key: "obs", label: "Observação", align: "left", visible: true },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Tipo do cliente", value: "nome" }],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const response = await reqTipoCliente.listPaginate(param, paramValue, active, newPage, perPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqTipoCliente.listID(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqTipoCliente.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterClientType;
